import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.sass']
})
export class NotificationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
    
    // if (this.data.redirectUrl) {
    //   this.router.navigate([this.data.redirectUrl]);
    // }
  }

  getStatusClass(status: string): string {
    if (!status) return ''
    return status.toLowerCase().replace(/\s+/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }

  getStatusIcon(status: string): string {
    switch (status.toLowerCase()) {
      case 'concluida': return 'check_circle'
      case 'aprovada': return 'thumb_up'
      case 'pendente': return 'hourglass_empty'
      case 'em-teste': return 'science'
      case 'em-analise': return 'visibility'
      case 'cancelada': return 'cancel'
      case 'reprovada': return 'thumb_down'
      default: return 'info'
    }
  }
}
